import React from 'react';

import { CircularProgress } from '@material-ui/core';
import { CircularProgressProps } from '@material-ui/core/CircularProgress/CircularProgress';

const Spinner: React.FC<CircularProgressProps> = (props) => <CircularProgress style={{ margin: 'auto' }} {...props} />;

export default Spinner;
